"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DataTable;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _tableModule = _interopRequireDefault(require("./table.module.scss"));
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _Checkbox = require("@ccw-pwa-ui/Checkbox");
var _Pagination = require("@ccw-pwa-ui/Pagination");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/no-array-index-key */

function TableNoRecord(_ref) {
  let {
    colSpan,
    show,
    isLoading,
    headingTitle,
    headerDesc
  } = _ref;
  if (!show || isLoading) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    colSpan: colSpan
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _tableModule.default.noDataFoundContainer
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _tableModule.default.errorMessage
  }, headingTitle ? headingTitle : ""), /*#__PURE__*/_react.default.createElement("span", {
    className: _tableModule.default.errorMessageInfo
  }, headerDesc ? headerDesc : ""))));
}
function TableLoading(_ref2) {
  let {
    colSpan,
    isLoading,
    headingTitle,
    headerDesc
  } = _ref2;
  if (!isLoading) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    colSpan: colSpan
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _tableModule.default.noDataFoundContainer
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _tableModule.default.errorMessage
  }, headingTitle ? headingTitle : ""), /*#__PURE__*/_react.default.createElement("span", {
    className: _tableModule.default.errorMessageInfo
  }, headerDesc ? headerDesc : ""))));
}

/**
 * @param {*} :
 *    columnData: data/content of table
  *   columnCount: pagesizre of table
  *   tableSchema: template of data table,
  *   loadMore: function to call api for load more data
  *   isResponsive/isHover for material ui table attribute accepts Boolean
  *   className attributes for header and columns
  *   noData: to show no data found
  *   headerClass : class name for header row i.e tr
  *   rowProps: contains className and onClick function which are applied on columns
 */

/**
 * @param {*} :tableSchema
 * header:
 *    renderHeader render's component
 *    className: class for header column
 *    colSpan: class for header colSpan
 *
 * tableBody:
 *    render render's component
 *    className: class for cell
 *    onClick: click function for column
 *    style: style for one cell
 */

function DataTable(props) {
  const {
    allowRowClick,
    isReponsive,
    isHover,
    headerClass,
    isLoadMore,
    isLoading,
    handleLoadMore,
    handleRowClick,
    handleAllRowSelected,
    allRowSelected,
    handleRowSelect,
    rowSelectedList,
    headerSchema,
    bodySchema,
    paginationProps,
    noDataProps,
    loadingDataProps,
    checkBoxPosition,
    testID,
    userStatusData,
    image,
    statusModalFlag,
    statusModalShow,
    activeRowStyle
  } = props;
  // const loadMore = async () => {
  //   //   const columnCount = this.state.columnCount + 20;
  //   //   this.setState({
  //   //     columnCount,
  //   //     filteredData: this.props.columnData.slice(0, columnCount),
  //   //   });
  //   if (handleLoadMore) {
  //     handleLoadMore();
  //   }
  // };

  let headerKeys = [];
  let headerValue = [];
  if (Array.isArray(headerSchema)) {
    headerSchema.forEach(headerObj => {
      Object.keys(headerObj).forEach((headerKey, j) => {
        headerKeys.push(headerKey);
        headerValue.push(headerObj[headerKey]);
      });
    });
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _tableModule.default.tableContainer,
    "data-testid": testID
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Table, {
    responsive: isReponsive,
    hover: isHover
  }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", {
    className: headerClass || ''
  }, props.checkboxPosition === "left" ? /*#__PURE__*/_react.default.createElement("th", {
    "data-testid": "table-header-check"
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.Checkbox, {
    checked: allRowSelected,
    onChange: () => {
      handleAllRowSelected(!allRowSelected);
    },
    disabled: bodySchema !== null && bodySchema !== void 0 && bodySchema.length ? false : true
  })) : null, headerValue.map((headerObj, i) => /*#__PURE__*/_react.default.createElement("th", {
    key: i
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: headerObj,
    headerStyle: {
      fontSize: 16,
      color: '#9A9A9A',
      fontWeight: 600,
      fontFamily: 'Poppins'
    },
    userStatusData: userStatusData,
    image: image,
    statusModalShow: statusModalShow,
    statusModalFlag: statusModalFlag
  }))), props.checkboxPosition === "right" ? /*#__PURE__*/_react.default.createElement("th", {
    "data-testid": "table-header-check"
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.Checkbox, {
    checked: allRowSelected,
    onChange: () => {
      handleAllRowSelected(!allRowSelected);
    },
    disabled: bodySchema.length ? false : true
  })) : null)), /*#__PURE__*/_react.default.createElement("tbody", {
    className: "device-list-tbody"
  }, !isLoading && bodySchema && Array.isArray(bodySchema) && bodySchema.map((row, j) => /*#__PURE__*/_react.default.createElement("tr", {
    key: j,
    className: "".concat(row.isActive === false || row.isActive === 'InActive' ? "disabledRow" : ""),
    "data-testid": "table-tbody-row",
    onClick: e => allowRowClick && (row.isActive === true || row.isActive === 'Active') ? handleRowClick(e, row, j) : null,
    style: rowSelectedList.includes(row.id) || allRowSelected ? {
      background: '#F4F4F4'
    } : row.isActive === true || row.isActive === 'Active' ? activeRowStyle || {
      background: 'transparent'
    } : {
      background: 'transparent',
      color: '#9A9A9A'
    }
  }, props.checkboxPosition == "left" ? /*#__PURE__*/_react.default.createElement("td", {
    "data-testid": "table-tbody-check",
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.Checkbox, {
    disabled: row.isActive === true || row.isActive === 'Active' ? false : true,
    checked: (rowSelectedList.includes(row.id) || allRowSelected) && (row.isActive === true || row.isActive === "Active"),
    onChange: () => {
      handleRowSelect(row.id);
    },
    "data-testid": "table-row-check"
  })) : null, headerKeys.map((headerKey, k) => headerKey !== "invitationStatus" ? /*#__PURE__*/_react.default.createElement("td", {
    key: k
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: row[headerKey],
    headerStyle: {
      fontSize: 16,
      color: "".concat(row.isActive === true || row.isActive === 'Active' ? '#333333' : "#9A9A9A"),
      fontWeight: 400,
      fontFamily: 'Poppins'
    }
  })) : /*#__PURE__*/_react.default.createElement("td", {
    key: k
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "Invite-header-text",
    headerText: row[headerKey]
  }))), props.checkboxPosition == "right" ? /*#__PURE__*/_react.default.createElement("td", {
    "data-testid": "table-tbody-check",
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.Checkbox, {
    checked: rowSelectedList.includes(row.id) || allRowSelected,
    onChange: () => {
      handleRowSelect(row.id);
    },
    "data-testid": "table-row-check"
  })) : null)), /*#__PURE__*/_react.default.createElement(TableLoading, {
    colSpan: headerKeys.length + 1,
    isLoading: isLoading,
    headingTitle: loadingDataProps.headingTitle,
    headerDesc: loadingDataProps.headerDesc
  }), /*#__PURE__*/_react.default.createElement(TableNoRecord, {
    colSpan: headerKeys.length + 1,
    show: !bodySchema || bodySchema.length < 1,
    isLoading: isLoading,
    headingTitle: noDataProps.headingTitle,
    headerDesc: noDataProps.headerDesc
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: _tableModule.default.paginationStyle
  }, /*#__PURE__*/_react.default.createElement(_Pagination.Pagination, {
    totalLength: paginationProps.totalLength,
    currentPage: paginationProps.currentPage,
    pageSize: paginationProps.pageSize,
    handlePageChange: paginationProps.handlePageChange,
    paginationStyle: paginationProps.paginationStyle,
    classes: _tableModule.default,
    isLoading: isLoading
  })));
}